/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Overview_TitleInputs */

const en_ticket_overview_title = /** @type {(inputs: Ticket_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

const ja_ticket_overview_title = /** @type {(inputs: Ticket_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チケット`)
};

const fr_ticket_overview_title = /** @type {(inputs: Ticket_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

const de_ticket_overview_title = /** @type {(inputs: Ticket_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

/**
* | output |
* | --- |
* | "Tickets" |
*
* @param {Ticket_Overview_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_overview_title = /** @type {((inputs?: Ticket_Overview_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Overview_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_overview_title(inputs)
	if (locale === "ja") return ja_ticket_overview_title(inputs)
	if (locale === "fr") return fr_ticket_overview_title(inputs)
	return de_ticket_overview_title(inputs)
});